<template>
    <div class="main-body">
        <div class="header">物品列表</div>
        <div class="out">

            <div class="search2">

              <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

              <div style="float:right">
                  <el-input  placeholder="请输入物品名称" v-model="name" clearable style="margin:0 5px;width:120px"></el-input>
                  <el-select v-model="warehouseCode" placeholder="请选择仓库" clearable style="margin:0 5px;width:120px;">
                      <el-option
                              v-for="item in warehouseCodeValue"
                              :key="item.warehouseCode"
                              :label="item.name"
                              :value="item.warehouseCode">
                      </el-option>
                  </el-select>
                  <el-select v-model="supplierCode" placeholder="请选择供应商" clearable style="margin:0 5px;width:120px;">
                      <el-option
                              v-for="item in SupplierCodeValue"
                              :key="item.supplierCode"
                              :label="item.name"
                              :value="item.supplierCode">
                      </el-option>
                  </el-select>
                  <el-select v-model="waresTypeCode" placeholder="请选择类型" clearable style="margin:0 5px;width:120px;">
                      <el-option
                              v-for="item in WaresTypeCodeValue"
                              :key="item.waresTypeCode"
                              :label="item.name"
                              :value="item.waresTypeCode">
                      </el-option>
                  </el-select>
                  <el-select v-model="status" placeholder="选择物品状态" style="margin:0 5px;width:100px;">
                      <el-option
                              v-for="item in status2"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                      </el-option>
                  </el-select>
                  <el-button size="mini" style="margin-left:10px;float:right" plain type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
              </div>

              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                <el-table-column prop="name" label="物品名称"></el-table-column>

                <el-table-column prop="price" label="单价"></el-table-column>

                <el-table-column prop="supplierName" label="供应商"></el-table-column>

                <el-table-column prop="waresTypeName" label="物品类型"></el-table-column>

              <el-table-column prop="stock" label="库存">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="handleInfo(scope.$index, scope.row)">{{scope.row.stock}}</el-button>
                </template>
              </el-table-column>


              <el-table-column prop="specifications" label="规格"></el-table-column>
              <el-table-column prop="manufacturer" label="生产企业"></el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>




              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                </template>
              </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd"  v-bind:SupplierCodeValue="SupplierCodeValue"  v-bind:WaresTypeCodeValue="WaresTypeCodeValue"  v-bind:warehouseCodeValue="warehouseCodeValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:SupplierCodeValue="SupplierCodeValue"  v-bind:WaresTypeCodeValue="WaresTypeCodeValue"  v-bind:warehouseCodeValue="warehouseCodeValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

      <StockInInfo ref="myStockInInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></StockInInfo>


    </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Edit from "./Edit";
    import Add from "./Add";
import StockInInfo from "./StockInInfo";


    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                showModalAdd:false,
                showModalEdit:false,
              showModalInfo:false,

                tableData:null,
                status:-1,
                totalItems: 0,
                name:'',
                pageSize:20,
                currentPage:1,
                supplierCode:'',
                waresTypeCode:'',
                warehouseCode:'',
                th:0,
                SupplierCodeValue:[],
                WaresTypeCodeValue:[],
                warehouseCodeValue:[],
                status2: [{
                    value: -1,
                    label: '所有状态'
                },{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '禁用'
                }],
            }
        },
        components:{
            Add,Edit,StockInInfo
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Warehouse/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response) => {
                        if (response.data.error == 0) {
                            this.warehouseCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    })


                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Supplier/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response) => {
                        if (response.data.error == 0) {
                            this.SupplierCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    })

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"WaresType/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response) => {
                        if (response.data.error == 0) {
                            this.WaresTypeCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    })


            },

          toggleModalAdd:function(){
              this.showModalAdd = !this.showModalAdd;
              this.$refs.myAdd.init();
          },
          closeAdd:function(){
              this.showModalAdd = !this.showModalAdd;
          },

          handleEdit(index, row) {
            this.$refs.myEdit.init(row);
            this.showModalEdit = !this.showModalEdit;
          },
          closeEdit:function(){
              this.showModalEdit = !this.showModalEdit;
          },

          handleInfo(index, row) {
            this.$refs.myStockInInfo.init(row);
            this.showModalInfo = !this.showModalInfo;
          },
          closeInfo:function(){
            this.showModalInfo = !this.showModalInfo;
          },

          current_change:function(currentPage){
              this.currentPage = currentPage;
              this.getList();
          },

          getList(){
              this.loading=true;
              var supplierCode=this.supplierCode;
              var waresTypeCode=this.waresTypeCode;
              var warehouseCode=this.warehouseCode;

              if(!supplierCode){
                  supplierCode='00000000-0000-0000-0000-000000000000'
              }
              if(!waresTypeCode){
                  waresTypeCode='00000000-0000-0000-0000-000000000000'
              }
              if(!warehouseCode){
                  warehouseCode='00000000-0000-0000-0000-000000000000'
              }

              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"Wares/Page",
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),
                      waresTypeCode:waresTypeCode,
                      supplierCode:supplierCode,
                      warehouseCode:warehouseCode,
                      name:this.name,
                      status:this.status,
                      pageIndex:this.currentPage,
                      pageSize:this.pageSize,
                  }
              }).then( (response)=> {
                  this.loading=false;

                  if(response.data.error == 0){
                      this.tableData = response.data.data.list;
                      this.totalItems = response.data.data.total;
                  }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          },
          statusTitle(row){
              if(row.status == 0){
                  return "正常";
              }
              if(row.status == 1){
                  return "禁用";
              }
              return "其它";
          },

          timefilter(row, column, cellValue){
            return timefilters(cellValue)
          },


        }
    }
</script>

<style lang='scss' scoped>


</style>
